import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Head from 'next/head';
import Link from 'next/link';
import { useContext, useEffect } from 'react';

import constMeta from '@/contents/constants/constMeta';
import OutLineButton from '@/contents/General/OutLineButton';
import Stack from '@/contents/General/Stack';
import Typography from '@/contents/General/Typography';
import { GlobalContext } from '@/contents/hooks/state';
import IllustLabList from '@/contents/IllustLab/IllustLabList';
import Layout from '@/layouts';
import { createClient } from '@/prismicio';
import theme from '@/styles/theme';
import type { NextPageWithLayout } from '@/types';
import { Page } from '@/types/domain';

const Container = styled(Box)`
  position: relative;
  padding: 0 ${theme.spacing(3)};
`;

// todo: fix
const Index: NextPageWithLayout = ({ illustList }: any) => {
  const { setPage } = useContext(GlobalContext);
  useEffect(() => {
    setPage(Page.ABOUT);
  }, []);

  return (
    <>
      <Head>
        <title>{constMeta.illustList.title}</title>
        <meta
          name="description"
          content={constMeta.illustList.mata_description}
        />
        <meta property="og:title" content={constMeta.illustList.title} />
        <meta
          property="og:description"
          content={constMeta.illustList.mata_description}
        />
        <meta
          property="og:image"
          content="https://iihi.life/assets/images/common/ogp.jpg"
        />
      </Head>
      <Container>
        <Box paddingTop={5} paddingBottom={6}>
          <Typography
            fontSize={28}
            fontWeight={700}
            paddingBottom={3}
            variant="h1"
          >
            イラスト素材一覧
          </Typography>
          <Typography fontSize={15} paddingBottom={5} lineHeight={1.6}>
            キャンプライフの様々なシーンを描いたイラスト素材です。キャンプ場内の掲示物やSNSのバナー画像などにご活用ください。
          </Typography>
          <Stack flexWrap="wrap" between>
            {illustList?.data?.illust_list.map(
              (
                illust: { title: string; image: { url: string } },
                index: string | number | null | undefined
              ) => (
                <IllustLabList
                  key={index}
                  title={illust.title}
                  imageUrl={illust.image.url}
                />
              )
            )}
          </Stack>

          <Stack center>
            <Link href="/illust">
              <a>
                <OutLineButton
                  textCenter
                  fontsize={14}
                  text="前のページに戻る"
                  sx={{ width: '246px', padding: '11px 0' }}
                ></OutLineButton>
              </a>
            </Link>
          </Stack>
        </Box>
      </Container>
    </>
  );
};

Index.getLayout = (page) => <Layout>{page}</Layout>;

export default Index;

export async function getStaticProps({ previewData }: any) {
  const client = createClient({ previewData });
  const illustList = await client.getByUID('illusttop', 'uid');
  return {
    props: {
      illustList,
    },
    revalidate: 60,
  };
}
